import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import { digits } from '@nodes/helpers/number';
import Props from './props';

@Component({
    components: {},
})

/**
 * @name Counter
 */
export default class Counter extends Mixins(HybridMixin, Props) {
    digits = digits;
}
